import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logVisit } from '../services/visitorLogService';
import './SubscriptionPage.css';

const generateRefId = (length = 20) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const MsisdnCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const params = new URLSearchParams(location.search);
    const msisdn = params.get('Msisdn');

    // Remove etracker params, keep the rest (pid, clickid, ad_id, etc.)
    params.delete('Status');
    params.delete('TelcoID');
    params.delete('Msisdn');
    const cleanQuery = params.toString();

    // Log the visit here (with the identified MSISDN) as early as possible, so the
    // visitor_log row carries the MSISDN + pid/clickid/ad_id before the WAP MO fires.
    // This is what lets the backend map the AIS conversion by MSISDN.
    const run = async () => {
      if (msisdn) {
        const refId = generateRefId(20);
        try {
          await logVisit(refId, msisdn, cleanQuery);
        } catch (e) {
          console.error('MSISDN callback logVisit failed:', e);
        }
      }

      // Preserve msisdn for the AIS page
      if (msisdn) params.set('msisdn', msisdn);
      const query = params.toString();
      navigate(`/subscription/ais${query ? '?' + query : ''}`);
    };

    run();
  }, [location, navigate]);

  return (
    <div className="subscription-page">
      <div className="subscription-content">
        <p>กำลังตรวจสอบผู้ให้บริการ...</p>
      </div>
    </div>
  );
};

export default MsisdnCallbackPage;
